import "./GridLayRemoveScroll.css";
import GoogleMapIcon from "../../../maps/assets/google-map-icon.png";
import houseIconGrid from "../../assets/houseIconGrid.png";
import townHouseIconGrid from "../../assets/townhouseGrid.png";
import condoIconGrid from "../../assets/condoIconGrid.png";
import commercialIconGrid from "../../assets/commercialIconGrid.png";
import landIconGrid from "../../assets/landIconGrid.png";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { useContext, useEffect, useState, useRef } from "react";
import { BiSearch } from "react-icons/bi";
import { GridLoader, BeatLoader, MoonLoader } from "react-spinners"; // Added MoonLoader
import FormatPrice from "../shared/PriceFormatter";
import FormatDateTime from "../../../../shared/utils/dateUtils";
import ModalDetail from "../../../maps/components/PropertyModal";
import LogoPostperty from "../../../maps/assets/markerIcon/production/1. LOGO-Postperty.webp";
import { GalleryContext } from "../../../../../App";
import { motion } from "framer-motion";
import HouseGoldenGrid from "./grid_icon/grid_house_icon.png"
import CondoGoldenGrid from "./grid_icon/grid_condo_icon.png"
import LandGoldenGrid from "./grid_icon/grid_land_icon.png"
import CommercialGoldenGrid from "./grid_icon/grid_commercial_icon.png"
import FactoryGoldenGrid from "./grid_icon/grid_factory_icon.png"
import TownhouseGoldenGrid from "./grid_icon/grid_other_icon.png"

const GridLayoutDisplay = ({
  statusHalfGridMap,
  setStatusHalfGridMap,
  statusCloseMap,
  SetStatusCloseMap,
  dataSearchValue,
  setSearchValue,
  isSearching,
  dataDisplay,
  setDataDisplay,
  setHeightStep,
  heightStep,
  mainDataModal,
  setMainDataModal,
}) => {
  const [savePositionBeforeUserExitPage, setSavePositionBeforeUserExitPage] =
    useState(sessionStorage.getItem("positionGridLayoutBeforeSeeDetail"));
  const [amountAsset, setAmountAsset] = useState(0);
  const [textSearchValue, setTextSearchValue] = useState("");
  const [isDownloadingDataAsset, setIsDownloadingDataAsset] = useState(true);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [PopUpPolicyCookies, setPopUpPolicyCookies] = useState(
    localStorage.getItem("firstComeReadCookiePolicyOnGridLayoutPage") === null
  );
  const { isGalleryOpen, setIsGalleryOpen, isClickContactModalDetail, setIsClickContactModalDetail } = useContext(GalleryContext);
  const typeIconGrids = {
    house: houseIconGrid,
    townhouse: townHouseIconGrid,
    condo: condoIconGrid,
    land: landIconGrid,
    commercial: commercialIconGrid,
  };

  const typeGoldenIconGrid = {
    house: HouseGoldenGrid,
    townhouse: TownhouseGoldenGrid,
    condo: CondoGoldenGrid,
    land: LandGoldenGrid,
    commercial: CommercialGoldenGrid,
    other : FactoryGoldenGrid
  }

  // Framer motion for switch toggle button
  const initialTop = 8 * 16; // 8rem converted to pixels (assuming 1rem = 16px)
  const dragDistance = 450; // Allow dragging up and down by 450 pixels
  const [userBlurSearch, setUserBlurSearch] = useState(false);
  const dragUpDistance = 70;
  const dragDownDistance = 420;
  const elementRef = useRef(null);
  const [constraints, setConstraints] = useState({ left: 0, right: 0, top: 0, bottom: 0 });

  useEffect(() => {
    const updateConstraints = () => {
      if (elementRef.current) {
        const { offsetWidth } = elementRef.current;
        setConstraints({
          left: 0,
          right: window.innerWidth - (offsetWidth + 19),
          top: -dragUpDistance,
          bottom: dragDownDistance,
        });
      }
    };

    updateConstraints();
    window.addEventListener("resize", updateConstraints);
    return () => window.removeEventListener("resize", updateConstraints);
  }, [dragUpDistance, dragDownDistance]);

  const changeStatusMap = () => {
    SetStatusCloseMap(false);
    setStatusHalfGridMap(true);
    localStorage.setItem("tempSwitchToMarkerOfGoogleMap", false);
    const url = new URL(window.location);
    url.searchParams.set("gridDisplay", "false");
    window.history.pushState({}, "", url);
  };

  useEffect(() => {
    setTimeout(
      () =>
        window.scrollTo(
          0,
          parseInt(
            sessionStorage.getItem("positionGridLayoutBeforeSeeDetail") || "0",
            10
          )
        ),
      1111
    );
    const statusUserClickToNavigation = localStorage.getItem(
      "tempSwitchToMarkerOfGoogleMap"
    );
    if (statusUserClickToNavigation === "true") {
      changeStatusMap();
    }
  }, []);

  useEffect(() => {
    const oldPosition = sessionStorage.getItem(
      "positionGridLayoutBeforeSeeDetail"
    );
    if (oldPosition !== null) {
      window.scrollTo({ top: oldPosition, behavior: "smooth" });
      sessionStorage.removeItem("positionGridLayoutBeforeSeeDetail");
      sessionStorage.removeItem("statusCloseMap");
    }
  }, [statusCloseMap]);

  useEffect(() => {
    const handleScroll = debounce(() => {
      if (
        !loading &&
        window.innerHeight + document.documentElement.scrollTop >=
          document.documentElement.offsetHeight - 600
      ) {
        setLoading(true);
        setPage((prevPage) => prevPage + 1);
        getMultipleAssetWithPage();
      }
    }, 300);

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [loading]);

  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func(...args), delay);
    };
  };

  const getMultipleAssetWithPage = () => {
    const apiUrl = `${process.env.REACT_APP_API}/asset/getMultipleAsset?page=${page}`;
    axios
      .get(apiUrl)
      .then((res) => {
        const data = res.data.assets;
        const totalAsset = res.data.statistic.total.total_assets;
        setAmountAsset(totalAsset);
        if (data.length !== 0) {
          setDataDisplay((prevData) => {
            const uniqueData = [...prevData, ...data].filter(
              (v, i, a) => a.findIndex((t) => t.id === v.id) === i
            );
            return uniqueData;
          });
        }
        setLoading(false);
        setTimeout(() => setIsDownloadingDataAsset(false), 1500);
      })
      .catch(() => {
        setLoading(false);
        setIsDownloadingDataAsset(false);
      });
  };

  useEffect(() => {
    getMultipleAssetWithPage();
  }, []);

  const handleValueSearch = (e) => setTextSearchValue(e.target.value);

  const handleSearchValueClicked = () => {
    const searchText = textSearchValue.trim();
    if (searchText.length === 0) {
      setSearchValue("");
    } else if (searchText.length > 1) {
      setSearchValue(searchText);
    }
  };

  const handleSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      e.currentTarget.blur(); // ปิดคีย์บอร์ดบนมือถือ
      handleSearchValueClicked();
    }
  };

  const saveScrollPosition = (linkRedirect) => {
    const scrollPosition = window.scrollY;
    setSavePositionBeforeUserExitPage(scrollPosition);
    sessionStorage.setItem("positionGridLayoutBeforeSeeDetail", scrollPosition);
    sessionStorage.setItem("statusCloseMap", true);
    localStorage.setItem("isNewTab", "true");
    window.open(linkRedirect, "_blank");
  };

  function formatNumberWithCommas(value) {
    if (typeof value === "string") {
      value = value.replace(/,/g, "");
    }
    const numberValue = parseFloat(value);
    if (!isNaN(numberValue)) {
      return numberValue.toLocaleString();
    }
    return value;
  }

  const handleOpenDetailPost = (linkDetails) => saveScrollPosition(linkDetails);

  const handleSwitchToGoogleMapAndOpenMarker = (idAsset) => {
    axios
      .post(`${process.env.REACT_APP_API}/fetchdata/get-latlng`, {
        asset_id: idAsset,
      })
      .then(async (res) => {
        const idMarker = res.data.id;
        await localStorage.setItem("positionBeforeExitedPage", JSON.stringify(res.data));
        await sessionStorage.setItem("confirmShowInfoWindowWithPosition", idMarker);
        if (window.innerWidth < 822) {
          changeStatusMap();
        } else {
          SetStatusCloseMap(false);
          setStatusHalfGridMap(true);
        }
      })
      .catch((err) => console.log(err));
  };

  const handleConfirmPolicyCookies = () => {
    setPopUpPolicyCookies(false);
    localStorage.setItem("firstComeReadCookiePolicyOnGridLayoutPage", "false");
  };

  const token = localStorage.getItem("token");

  const getDetailMarker = (id) => {
    axios
      .get(`${process.env.REACT_APP_API}/product/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        console.log(res.data);
        setMainDataModal(res.data.asset);
      })
      .catch((err) => {
        console.log(err.response.data);
      });
  };

  async function handleItemOnClick(itemData) {
    console.log("handleItemOnClick", itemData);
    await getDetailMarker(itemData.id);
    setHeightStep("half");
    const url = new URL(window.location);
    url.searchParams.set("card", "half");
    url.searchParams.set("aid", itemData.id);
    if (itemData.lat !== undefined) {
      url.searchParams.set("lat", itemData.lat);
    }
    if (itemData.lng !== undefined) {
      url.searchParams.set("lng", itemData.lng);
    }
    window.history.pushState({}, "", url);
  }

  const renderGrid = (post) => (
    <article
      key={post.id}
      onClick={() => handleItemOnClick(post)}
      className={`w-full bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-200 cursor-pointer ${post.sold ? "opacity-50" : ""} ${post.status ? "opacity-30" : ""}`}
    >
      {/* ── Image ── */}
      <div className="relative w-full h-44 overflow-hidden">
        <img
          src={post.images_url.AssetImagesURL[0]}
          className="w-full h-full object-cover"
          loading="lazy"
          alt=""
          onError={(e) => { e.target.src = '/bg-login.jpg'; e.target.onerror = null; }}
        />

        {/* type + sale badge */}
        <div className="absolute top-2 left-2 flex gap-1 flex-wrap">
          {post.type_post.Type.map((t, i) => (
            <span key={i} className={`text-xs font-semibold px-2.5 py-0.5 rounded-full ${post.official ? "bg-amber-400 text-white" : "bg-white/90 text-gray-800"}`}>
              {t}
            </span>
          ))}
        </div>

        {/* official icon */}
        {post.official && !post.sold && (
          <img className="absolute top-0 left-0 w-12 h-12" src={typeGoldenIconGrid[post.type]} alt="" />
        )}

        {/* sold overlay */}
        {post.sold && (
          <div className="absolute inset-0 z-10 flex items-center justify-center bg-black/40">
            <span className="bg-red-600 text-white text-xs font-black px-4 py-1.5 rounded-full tracking-widest uppercase shadow-lg">
              ขายแล้ว
            </span>
          </div>
        )}

        {/* right-side action icons */}
        <div className="absolute top-2 right-2 flex flex-col gap-1.5" onClick={(e) => e.stopPropagation()}>
          {post.media.vr_url && (
            <Link target="_blank" to={post.media.vr_url}>
              <img src="https://cdn-icons-png.flaticon.com/512/5510/5510739.png" alt="VR" className="w-8 h-8 bg-white p-1 rounded-full shadow-md" />
            </Link>
          )}
          {post.media.YoutubeURL && (
            <Link target="_blank" to={post.media.YoutubeURL}>
              <img src="https://cdn-icons-png.flaticon.com/512/3665/3665173.png" alt="YouTube" className="w-8 h-8 bg-white p-1 rounded-full shadow-md" />
            </Link>
          )}
          <img
            src="https://cdn-icons-png.flaticon.com/512/6401/6401832.png"
            alt="map"
            className="w-8 h-8 bg-white p-1 rounded-full shadow-md cursor-pointer"
            onClick={(e) => { e.stopPropagation(); handleSwitchToGoogleMapAndOpenMarker(post.id); }}
          />
        </div>
      </div>

      {/* ── Info ── */}
      <div className="px-3 pt-2.5 pb-3">
        {/* price */}
        <p className={`font-bold text-base ${post.official ? "text-amber-500" : "text-emerald-600"}`}>
          {post.imperfect_asset
            ? "ราคาติดต่อผู้ขาย"
            : post.sell_price !== null
            ? `${formatNumberWithCommas(post.sell_price)} บาท`
            : post.rent_price !== null
            ? `${formatNumberWithCommas(post.rent_price)} บาท`
            : `${formatNumberWithCommas(post.sellout_price)} บาท`}
        </p>

        {/* title */}
        <p className="text-sm font-semibold text-gray-900 mt-0.5 leading-snug">
          {post.title.slice(0, 32)}...
        </p>

        {/* description */}
        <p className="text-xs text-gray-400 mt-0.5 leading-relaxed">
          {post.description.slice(0, 40)}...
        </p>

        {/* room/size pills */}
        {post.land.living_size ? (
          <div className="flex items-center gap-1.5 mt-2 flex-wrap">
            {post.rooms.Bedroom > 0 && (
              <span className="flex items-center gap-1 text-xs bg-gray-50 border border-gray-100 rounded-full px-2 py-0.5 text-gray-600">
                <svg xmlns="http://www.w3.org/2000/svg" className="w-3 h-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M3 12V7a2 2 0 012-2h14a2 2 0 012 2v5M3 12h18M3 12v5m18-5v5M3 17h18"/></svg>
                {post.rooms.Bedroom}
              </span>
            )}
            {post.rooms.Bathroom > 0 && (
              <span className="flex items-center gap-1 text-xs bg-gray-50 border border-gray-100 rounded-full px-2 py-0.5 text-gray-600">
                <svg xmlns="http://www.w3.org/2000/svg" className="w-3 h-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M4 12h16M4 12V7a3 3 0 016 0v5M4 12v4a2 2 0 002 2h12a2 2 0 002-2v-4"/></svg>
                {post.rooms.Bathroom}
              </span>
            )}
            <span className="flex items-center gap-1 text-xs bg-gray-50 border border-gray-100 rounded-full px-2 py-0.5 text-gray-600">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-3 h-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M4 4h6M4 4v6M4 4l6 6M20 20h-6m6 0v-6m0 6l-6-6"/></svg>
              {post.land.living_size !== "0" ? post.land.living_size : post.land.total_size}
              {post.land.living_unit === "ตารางเมตร" ? " ตร.ม" : " ตร.ว"}
            </span>
          </div>
        ) : post.land.rai ? (
          <div className="flex items-center gap-1.5 mt-2 flex-wrap">
            {post.land.rai > 0 && (
              <span className="text-xs bg-gray-50 border border-gray-100 rounded-full px-2 py-0.5 text-gray-600">{post.land.rai} ไร่</span>
            )}
            {post.land.ngan > 0 && (
              <span className="text-xs bg-gray-50 border border-gray-100 rounded-full px-2 py-0.5 text-gray-600">{post.land.ngan} งาน</span>
            )}
            {post.land.wah > 0 && (
              <span className="text-xs bg-gray-50 border border-gray-100 rounded-full px-2 py-0.5 text-gray-600">{post.land.wah} ตร.ว</span>
            )}
          </div>
        ) : null}

        {/* seller + date */}
        <div className="flex items-center justify-between mt-2.5 pt-2 border-t border-gray-50">
          <div className="flex items-center gap-1.5">
            <img src={post.user_data.user.profile_image} alt="" className="w-6 h-6 rounded-full object-cover bg-gray-100" />
            <span className="text-xs text-gray-500">{post.user_data.user.uname}</span>
            {post.user_data.user.verify_level === 3 && (
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2" width="14" height="14">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            )}
          </div>
          <time className="text-xs text-gray-400">
            <FormatDateTime isoDateString={post.date} />
          </time>
        </div>
      </div>
    </article>
  );

  return (
    <div className={`bg-gray-50 ${isGalleryOpen ? "md:hidden" : ""}`}>

      {/* ── PropertyModal (grid mode) ── */}
      {statusCloseMap && mainDataModal !== null && (
        <ModalDetail
          dataMainModal={mainDataModal}
          id={mainDataModal.id}
          setHeightStep={setHeightStep}
          heightStep={heightStep}
          statusComponent={"grid"}
        />
      )}

      {/* ── Floating map switch button (mobile only) ── */}
      {!statusHalfGridMap && (
        <motion.div
          ref={elementRef}
          className="fixed left-2 z-30 cursor-pointer lg:hidden"
          style={{ top: "8rem", width: "4.5rem" }}
          onClick={changeStatusMap}
          drag
          dragConstraints={constraints}
        >
          <div className="flex flex-col items-center bg-blue-500 rounded-2xl shadow-lg p-2.5">
            <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
              <img src={GoogleMapIcon} className="w-6 h-6" alt="Google Map Icon" />
            </div>
            <p className="text-[10px] text-white mt-1 text-center leading-tight font-medium">สลับมุมมอง</p>
          </div>
        </motion.div>
      )}

      {/* ── Search bar + count (mobile) ── */}
      {!isDownloadingDataAsset && (
        <div className="px-3 pt-3 pb-2">
          <div className="flex items-center bg-white rounded-2xl shadow-sm border border-gray-100 h-12 px-3 gap-2 md:hidden">
            <Link to="/" className="flex-shrink-0">
              <img src={LogoPostperty} className="w-8 h-8" alt="logo" />
            </Link>
            <div className="w-px h-5 bg-gray-200 flex-shrink-0" />
            <input
              value={textSearchValue}
              onChange={handleValueSearch}
              onKeyDown={handleSearchKeyDown}
              onBlur={() => setUserBlurSearch(true)}
              type="text"
              className="flex-1 outline-none text-sm text-gray-700 placeholder-gray-400 bg-transparent"
              placeholder="ค้นหาด้วยคีย์เวิร์ด"
            />
            <BiSearch
              onClick={handleSearchValueClicked}
              className={`flex-shrink-0 w-6 h-6 cursor-pointer transition-colors ${
                textSearchValue.length > 0 ? "text-blue-500" : "text-gray-400"
              }`}
            />
          </div>
          <p className="text-xs text-gray-400 text-center mt-2">
            พบ <span className="text-blue-500 font-semibold">{dataSearchValue.length > 0 ? dataSearchValue.length : dataDisplay.length}</span> รายการ
          </p>
        </div>
      )}

      {/* ── Loading ── */}
      {isDownloadingDataAsset && (
        <div className="flex justify-center items-center h-screen">
          <GridLoader color="#3b82f6" />
        </div>
      )}

      {/* ── Grid ── */}
      {!isDownloadingDataAsset && (
        isSearching ? (
          <div className="flex flex-col justify-center items-center gap-3 py-20">
            <MoonLoader size={28} color="#3b82f6" />
            <p className="text-sm text-gray-500">ระบบกำลังประมวลผล</p>
          </div>
        ) : (
          <div className="px-2 pb-6 grid grid-cols-2 gap-2">
            {(dataSearchValue.length === 0 ? dataDisplay : dataSearchValue).map((post) => renderGrid(post))}
          </div>
        )
      )}
    </div>
  );
};

export default GridLayoutDisplay;